import type { FC } from 'react';
import { memo, useCallback, useState } from 'react';
import { useWorkflowStore } from '../store';
import { Button } from 'antd';
import { useBoolean } from 'ahooks';
// import RunAndHistory from './run-and-history';
import { useNodesSyncDraft } from '../hooks';
import openWindow from '@/script/openWindow.mjs'
import useHTTP from '@/hooks/useHTTP.mjs'
import SoftwareMap from "@/components/SoftwareMap/SoftwareMap.jsx";
import Modal from "@/components/Modal/Modal";
import cn from '@/utils/classnames'
import { useReactFlow } from 'reactflow';

// import EditingTitle from './editing-title';

const Header: FC = () => {
  const [modalOpen, { setTrue: handleOpen, setFalse: handleCancel }] = useBoolean(false);
  const [mapData, setMapData] = useState({});
  const http = useHTTP();
  const workflowStore = useWorkflowStore();
  const { handleSyncWorkflowSave, handleSyncWorkflowUpdate } = useNodesSyncDraft();
  const { isPreview, prjData } = workflowStore.getState()
  const { fitView } = useReactFlow()
  const readMap = useCallback(async () => {
    if(!isPreview) return;
    try {
      const params = new URLSearchParams(location.search.split("?")[1]);
      const param: {
        prjPatternId?: string;
      } = {};
      let url = `/bmbfs/${prjData.bfId}`;
      if(params.get('prjPatternId')) {
        param.prjPatternId = params.get('prjPatternId');
        url = `/pattern/bmbfs/${prjData.bfId}`;
      }
      const res = await http.get(url, param)
      const { bfMap } = res
      setMapData(JSON.parse(bfMap));
      handleOpen()
    } catch (error) { 
      console.log(error)
    }

    
  }, [workflowStore]);
  const onPreview = useCallback(async e => {
    // 根据点击的时候是否按alt键来决定target是否为_self还是_target,兼容mac与window
    const target = e.altKey ? '_blank' : '_self'

    openWindow('/FlowPreview', { wfId: prjData.pkid }, '_blank')
  }, [workflowStore]);

  return (
    <div className={cn("absolute right-0 top-0 z-10 flex h-12  text-center items-center justify-between bg-mask-top2bottom-gray-50-to-transparent px-3",
    )}>
      {
        !isPreview && prjData.bfTypeCode == 'TARGET' && <div>
          <Button
            className='mr-3'
            onClick={() => {
              openWindow('/BfDetail', { bfId: prjData.bfId }, '_blank')
            }}
          >
            跳转逻辑图
          </Button>
        </div>
      }
      { !isPreview && prjData.bfTypeCode == 'TARGET' && <div>
        <Button className='mr-3' style={{ fontSize: '12px', lineHeight: '16px', borderRadius: '8px' }} onClick={handleSyncWorkflowUpdate}>
          更新制品
        </Button>
      </div>}
      <div>
        {/* {normal && <EditingTitle />} */}
        {/* {restoring && <RestoringTitle />} */}
        
        { !isPreview && <Button className='mr-3' type="primary" style={{ fontSize: '12px', lineHeight: '16px', borderRadius: '8px' }} onClick={() => {
          fitView()
          handleSyncWorkflowSave()
        }}>
          保存
        </Button>}
      </div>
      <div className="flex items-center gap-2 rounded-lg border-[0.5px] border-components-actionbar-border bg-components-actionbar-bg">
        {/* <RunAndHistory /> */}
        {/* <VersionHistoryButton onClick={onStartRestoring} /> */}
        {!isPreview && <Button style={{ fontSize: '12px', lineHeight: '16px', borderRadius: '8px' }} type="default" onClick={onPreview}>
          流程看板
        </Button>}
        {isPreview && <Button id='preview-map' style={{ fontSize: '12px', lineHeight: '16px', borderRadius: '8px' }} type="default" onClick={readMap}>
          查看逻辑图
        </Button>}
      </div>
      <Modal
        title="查看逻辑图"
        open={modalOpen}
        width={"60%"}
        bodyStyle={{ height: "calc(68vh - 100px)" }}
        centered
        destroyOnClose
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            关闭
          </Button>,
        ]}
      >
        <SoftwareMap mapData={mapData} />
      </Modal>
    </div>
  );
};

export default memo(Header);
